import { CourseCompletionBanner } from './CourseCompletionBanner';
import { CourseList } from './CourseList';
import { useLoggedInUser } from '~/pages/_shared/useLoggedInUser';
import { useCourseAssignmentIndividualStageSummaryDetails } from './useIndividualStageSummaryDetails';
import { useLocalization } from '~/framework';
import { Flex, CircularProgress, Text } from '@chakra-ui/react';
import { PageContainer } from '~/ui-components';

export function UserCourseSummaries() {
   const { data: user } = useLoggedInUser();
   const {
      data: courses,
      isLoading: loadingCourses,
      isFetched,
   } = useCourseAssignmentIndividualStageSummaryDetails(user?.userid);
   const { _js } = useLocalization();

   return (
      <>
         <CourseCompletionBanner userid={user?.userid} avatarUrl={user?.userAvatarUrl} />
         <PageContainer>
            {loadingCourses && (
               <Flex flex={1} direction="column" justify="center" alignItems="center">
                  <CircularProgress isIndeterminate color="blue.500" />
               </Flex>
            )}
            {courses?.urgentCourses.length ? (
               <CourseList
                  courses={courses.urgentCourses}
                  title={_js('Courses Needing Attention')}
                  subtitle={_js(
                     "These are courses that you've taken that need immediate attention."
                  )}
                  status={'Urgent'}
               />
            ) : null}
            {courses?.incompleteCourses.length ? (
               <CourseList
                  courses={courses.incompleteCourses}
                  title={_js('Assigned to Me')}
                  subtitle={_js(
                     'These are assignments that have not yet been completed or started.'
                  )}
                  status={'Incomplete'}
               />
            ) : null}
            {courses?.completedCourses.length ? (
               <CourseList
                  courses={courses.completedCourses}
                  title={_js('My Course Competency')}
                  subtitle={_js('Below are courses that you have completed thoroughly.')}
                  status={'Complete'}
               />
            ) : null}
            {isFetched &&
               !courses?.urgentCourses.length &&
               !courses?.incompleteCourses.length &&
               !courses?.incompleteCourses.length && (
                  <Flex flex={1} direction="column" justify="center" alignItems="center">
                     <Text>{_js('No assigned courses')}</Text>
                  </Flex>
               )}
         </PageContainer>
      </>
   );
}
